import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
  Icon,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import 'moment/locale/pt-br';
import { dateTimeFormat } from '../../helpers/timeFormat';
import { getTypeLabel } from '../../helpers/request';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class ApprovedRequestsReportScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      period: '',
    };
  }

  static get propTypes() {
    return {
      registers: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}` }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { period } = this.state;

    var [startDate, endDate] = (period || '').split(' - ');
    // An empty/cleared filter must not be sent as an empty string - the backend then falls back to its own
    // default range (last 30 days) instead of failing to bind a date.
    startDate = startDate ? moment(startDate, DATE_FORMAT).format(FILTER_FORMAT) : null;
    endDate = endDate ? moment(endDate, DATE_FORMAT).format(FILTER_FORMAT) : null;

    dispatch(reportActions.fetchApprovedRequests({ startDate, endDate, export: isExport === true, exportPdf: isExport === 'pdf' }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  exportPdf() {
    this.fetchRegisters('pdf');
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Solicitações Aprovadas</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Aprovado em'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> XLSX
            </Form.Button>
            <Form.Button onClick={() => this.exportPdf()} label='&nbsp;'>
              <Icon name='file pdf' /> PDF
            </Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.length > 0 &&
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Usuário</Table.HeaderCell>
                <Table.HeaderCell>Tipo</Table.HeaderCell>
                <Table.HeaderCell>Início</Table.HeaderCell>
                <Table.HeaderCell>Duração</Table.HeaderCell>
                <Table.HeaderCell>Aprovador</Table.HeaderCell>
                <Table.HeaderCell>Aprovado em</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {registers.map((register) => {
                return <Table.Row key={register.Id}>
                  <Table.Cell>{register.Requester?.Name}</Table.Cell>
                  <Table.Cell>{getTypeLabel(register.Type)}</Table.Cell>
                  <Table.Cell>{dateTimeFormat(register.StartDate)}</Table.Cell>
                  <Table.Cell>{moment.duration(register.MinutesAmount, "minutes").format("HH:mm", { trim: false })}</Table.Cell>
                  <Table.Cell>{register.Approver?.Name}</Table.Cell>
                  <Table.Cell>{register.ApprovedAt ? dateTimeFormat(register.ApprovedAt) : '-'}</Table.Cell>
                </Table.Row>;
              })}
            </Table.Body>
          </Table>}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;
  return {
    registers: report?.approvedRequests || null,
    loading: report?.loading
  };
}

const connectedApprovedRequestsReportScreen = connect(mapStateToProps)(ApprovedRequestsReportScreen);
export { connectedApprovedRequestsReportScreen as ApprovedRequestsReportScreen };
